import { FC } from 'react';
import { TimeslotsScroll } from './styles';
import { ArrowLeftIconButton } from 'shared/ui/buttons/iconButtons/arrowLeftIconButton';
import { ArrowRightIconButton } from 'shared/ui/buttons/iconButtons/arrowRightIconButton';
import { Flex } from 'shared/ui/flex';
import { useTimeslots } from '../lib/timeslots/useTimeslots';
import TimeslotsListScroll from './timeslotsListScroll';

export const TimeslotsTool: FC = () => {
  // const TimeslotsWithLoader = withPreloader(
  //   TimeslotsListScroll,
  //   PreloaderContainer,
  // );

	const {
		timeslots,
		ref,
		scrollToRight,
		scrollToLeft,
		enableSlotUpdatesHandler,
		selectSlot,
	} = useTimeslots();

	return (
		<Flex
			$alignItems="center"
			data-testid="timeslots-list"
			$justify="space-between"
		>
			<ArrowLeftIconButton onClick={scrollToLeft} />
			<TimeslotsScroll data-testid="timeslots-scroll" ref={ref} $isScrollable={!window.matchMedia("(pointer: coarse)").matches ? false : true}>
        <TimeslotsListScroll 
          isLoading={false}
          timeslots={timeslots}
          enableSlotUpdatesHandler={enableSlotUpdatesHandler}
          selectSlot={selectSlot}
        />
			</TimeslotsScroll>
			<ArrowRightIconButton onClick={scrollToRight} />
		</Flex>
	);
};
